// extracted by mini-css-extract-plugin
export default {"virtual":"Virtual_virtual__fNA3C","left":"Virtual_left__95r5q","wrapper":"Virtual_wrapper__laNAC"};